<template>
	<div class="navbar__item">
		<button class="navbar__button" @click="toggleFilter" :class="{ 
			'navbar__button--active': viewstate.isActive || hasActiveFilters,
			'navbar__button--filtering': viewstate.isActive
		}">
			<img v-if="filter.navIcon" :src="filter.navIcon" class="navbar__button-icon" alt="">
			{{ filterTitle }}
		</button>
		<div class="filter" id="filter_grade">
			<div class="filter__options">
				<div class="filter__type" v-for="option in visibleOptions">
					<label>
						<input type="checkbox" class="filter__checkbox" v-model="option.isActive">
						<span class="filter__name">
							<img v-if="option.iconURL" :src="option.iconURL" alt="" class="filter__icon">
							<i v-else-if="option.iconClass" :class="['filter__icon', 'filter__icon--font', option.iconClass]"></i>
							<span>{{ option.title }}</span>
						</span>
					</label>
				</div>
			</div>
			<div class="filter__action">
				<a @click="toggleFilter">Bruk</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			handle: String,
			viewstate: Object,
			filter: Object,
			currentUser: { type: [Number, Boolean], default: false }
		},
		emits: ['updatefilter', 'hidefilters'],
		data() {
			return {
				filterTitle: '',
				hasActiveFilters: false
			};
		},
		computed: {
			// Options flagged loginRequired (e.g. "Mine favoritter",
			// "Registrerte turer") only make sense for a logged-in
			// visitor - hidden entirely rather than shown disabled, same
			// as the rest of the site treats logged-out-only visibility.
			visibleOptions() {
				return this.filter.options.filter((option) => !option.loginRequired || this.currentUser !== false);
			}
		},
		watch: {
			filter: {
				handler: function(state, oldState) {
					let selectedOptions = [];
					state.options.forEach((option) => {
						if (option.isActive) {
							selectedOptions.push(option);
						}
					});
					if (selectedOptions.length) {
						this.hasActiveFilters = true;
						if (selectedOptions.length === 1) {
							this.filterTitle = selectedOptions[0].title;
						}
						else {
							this.filterTitle = this.filter.title + ' - ' + selectedOptions.length;	
						}
					}
					else {
						this.hasActiveFilters = false;
						this.filterTitle = this.filter.title;
					}
					this.$emit('updatefilter', this.handle);
				},
				deep: true
			}
		},
		components: {
			
		},
		mounted() {
			this.filterTitle = this.filter.title;
		},
		methods: {
			toggleFilter() {
				if (this.viewstate.isActive) {
					this.hideFilter();
				}
				else {
					this.showFilter();
				}
			},
			hideFilter() {
				this.viewstate.isActive = false;
			},
			showFilter() {
				this.$emit('hidefilters');
				this.viewstate.isActive = true;
			},
			checkActive() {
				return this.viewstate.isActive;
			}
		}
	}
</script>

<style>

</style>